<template>
    <div>
        <button
            @click="addTTPP"
            type="button"
            class="px-4 py-2 bg-green-500 text-white rounded mb-5"
        >
            Tambah TTPP
        </button>
        <div
            v-for="(ttpp, index) in ttppList"
            :key="ttpp.id || index"
            class="ttpp-entry mb-3"
        >
            <div class="lg:w-full md:w-full">
                <div class="flex items-center gap-2">
                    <Dropdown
                        class="w-full"
                        v-model="ttppList[index].id"
                        :options="filteredTTPPOptions(ttpp.id)"
                        optionLabel="fullname"
                        optionValue="id"
                        filter
                        filterBy="fullname"
                        @filter="fetchTTPP"
                        @change="validateUniqueness(index)"
                        placeholder="Pilih Tim Teknis Perencanaan Pengadaan"
                    />
                    <button
                        @click="removeTTPP(index)"
                        class="px-4 py-2 bg-red-500 text-white rounded ml-2"
                    >
                        Hapus
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import Dropdown from "primevue/dropdown";
import axios from "axios";

export default defineComponent({
    components: {
        Dropdown,
    },
    props: {
        list_ttpp: Array,
        ttpp_id : String,
    },
    data() {
        const ttppInitialList = this.list_ttpp
            ? this.list_ttpp.map((item, idx) => ({
                ...item,
                ttppUniqueId: item.ttppUniqueId || this.ttppGenerateUniqueId(),
                ttppDisplayIndex: idx + 1
            }))
            : [];
        return {
            ttppOptions: [],
            ttppList: ttppInitialList,
            ttppNextIndex: (ttppInitialList.length > 0)
                ? Math.max(...ttppInitialList.map(item => item.ttppDisplayIndex || 0)) + 1
                : 1
        };
    },
    watch: {
        list_ttpp: {
            handler(ttppNewValue) {
                if (ttppNewValue) {
                    // Block recursive updates by checking if the internal change is happening
                    if (this._internalUpdate) return;
                    
                    // Preserve ttppUniqueIds if present, generate new ones if not
                    this.ttppList = ttppNewValue.map((item, idx) => ({
                        ...item,
                        ttppUniqueId: item.ttppUniqueId || this.ttppGenerateUniqueId(),
                        ttppDisplayIndex: item.ttppDisplayIndex || (idx + 1)
                    }));
                    
                    // Update ttppNextIndex based on highest current ttppDisplayIndex
                    if (this.ttppList.length > 0) {
                        this.ttppNextIndex = Math.max(
                            ...this.ttppList.map(item => item.ttppDisplayIndex || 0)
                        ) + 1;
                    }
                } else {
                    this.ttppList = [];
                    this.ttppNextIndex = 1;
                }
            },
            deep: true,
        },
        ttppList: {
            handler(ttppNewValue) {
                // Prevent recursive updates by setting a flag
                this._internalUpdate = true;
                // Emit the updated ttppList to the parent component
                this.$emit("update:list_ttpp", ttppNewValue);
                // Reset flag after this update cycle
                this.$nextTick(() => {
                    this._internalUpdate = false;
                });
            },
            deep: true,
        },
    },
    mounted() {
        this.fetchTTPP({ value: "" });
    },
    methods: {
        ttppGenerateUniqueId(){
            return Date.now() + '-' + Math.floor(Math.random() * 100);
        },
        addTTPP() {
        try {
            this.ttppList.push({
                id: null,
                ttppUniqueId : this.ttppGenerateUniqueId(),
                ttppDisplayIndex : this.ttppNextIndex
            });
            this.ttppNextIndex++;
            console.log('Updated list:', this.ttppList);
        } catch (error) {
            console.error('Error in addTTPP:', error);
        }
        //console.log("Berhasil klik");
        },
        removeTTPP(ttppIndex) {
            this.ttppList.splice(ttppIndex, 1);
        },
        async fetchTTPP(event) {
            console.log("Keyword : ", event.value);
            try {
                const response = await axios.post(
                    "/organisasi_pengadaan/search_ttpp",
                    {
                        params: {
                            keyword: event.value || "",
                        },
                    }
                );
                if (response.data && Array.isArray(response.data)) {
                    this.ttppOptions = response.data;
                }
            } catch (error) {
                console.error("Error fetching ttpp:", error);
            }
        },
        filteredTTPPOptions(ttppCurrentId) {
            // Ensure the currently selected option is available in the dropdown options
            return this.ttppOptions.concat(
                this.ttppList.filter(
                    (p) =>
                        p.id === ttppCurrentId &&
                        !this.ttppOptions.some(
                            (option) => option.id === ttppCurrentId
                        )
                )
            );
        },
        validateUniqueness(ttppCurrentIndex) {
            const ttppCurrentId = this.ttppList[ttppCurrentIndex]?.id;
            if (
                ttppCurrentId &&
                this.ttppList.filter(
                    (ttpp) => ttpp.id === ttppCurrentId
                ).length > 1
            ) {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "TTPP duplikat terdeteksi. Pastikan setiap ttpp unik.",
                    life: 3000,
                });
                this.ttppList[ttppCurrentIndex].id = null;
            }
        },
    },
});
</script>
